import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProjectComponent } from './components/project-list/project.component';
import { DetailsProjectComponent } from './components/details-project/details-project.component';
import { clientFinalGuard } from '@core/guards/client-final.guard';

const routes: Routes = [
  {
    path:'',
    redirectTo:'liste',
    pathMatch:"full"
  },
  {path : 'liste' , 
    component : ProjectComponent,
    canActivate: [clientFinalGuard.canActivate]
  },
  {path : 'detail-projets/:id' , component : DetailsProjectComponent,
    canActivate: [clientFinalGuard.canActivate]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectRoutingModule { }
